import { useMemo } from 'react';

import { menu, type MenuItem } from '@/consts/navigation';
import { buildDynamicSection } from '@/features/navigation/utils/buildDynamicSection';
import { useFavoritesStore } from '@/stores/useFavoritesStore';
import { useRecentsStore } from '@/stores/useRecentsStore';

export const useDynamicMenu = (): MenuItem[] => {
  const { favoriteCodes, favoritesLoading } = useFavoritesStore();
  const { recentCodes, recentsLoading } = useRecentsStore();

  return useMemo(() => {
    const allMenuItems = menu.flatMap((section) => section.children?.filter((child) => child.code) ?? []);

    return menu.map((section) => {
      if (section.text === 'navigation.favorites.title') {
        return buildDynamicSection(
          allMenuItems,
          section,
          favoriteCodes,
          favoritesLoading,
          'navigation.favorites.children.empty'
        );
      }
      if (section.text === 'navigation.recent.title') {
        return buildDynamicSection(
          allMenuItems,
          section,
          recentCodes,
          recentsLoading,
          'navigation.recent.children.empty'
        );
      }
      return section;
    });
  }, [favoriteCodes, favoritesLoading, recentCodes, recentsLoading]);
};
